import { apiClient } from '../api';

export const notificationsApi = {
  async listChannels() {
    const { data } = await apiClient.get('/api/notifications/channels');
    return data.channels;
  },

  async saveTelegram(payload) {
    const { data } = await apiClient.put('/api/notifications/channels/telegram', payload);
    return data.channel;
  },

  async testTelegram() {
    const { data } = await apiClient.post('/api/notifications/channels/telegram/test');
    return data;
  },

  // Bot name, chat name and whether the bot may post. bot_token is optional (saved one used).
  async checkTelegram(payload) {
    const { data } = await apiClient.post('/api/notifications/channels/telegram/check', payload);
    return data;
  },

  async findTelegramChats(payload) {
    const { data } = await apiClient.post('/api/notifications/channels/telegram/find-chat', payload);
    return data.chats;
  },

  async disconnectTelegram() {
    const { data } = await apiClient.delete('/api/notifications/channels/telegram');
    return data;
  },

  async listLog(limit = 5) {
    const { data } = await apiClient.get('/api/notifications/log', { params: { limit } });
    return data.log;
  },

  // { log, last_24h: { sent, failed, suppressed, held, … } }
  async logWithStats(limit = 20) {
    const { data } = await apiClient.get('/api/notifications/log', { params: { limit } });
    return data;
  },
};
